import {mapActions, mapGetters} from "vuex";
import {Wz5FormValidator} from "@/mixins/Wz5FormValidator";

export const Wz5FormProcess = {
    data() {
        return {
            timer: true,
        }
    },
    mixins: [Wz5FormValidator],
    computed: {
        ...mapGetters('WzCase', {
            wz_case: 'wz_case',
            wz_case_decision: 'wz_case_decision',
            user_ip: 'user_ip',
        }),
        ...mapGetters('Wz5Form', {
            wz5_form: 'wz5_form',
            process_loading: 'loading',
            process_error: 'error',
        }),
    },
    methods: {
        ...mapActions('Wz5Form', {
            updateWz5Form: 'updateWz5Form', 
            storeWzCaseDecision: 'storeWzCaseDecision',
            setWz5Form: 'setWz5Form'
        }),
        saveWz5Form: function () {
            let data = this.params;

            if (this.validateForm(data)) {
                this.submitWz5CaseDecision(this.prepareDecisions(data));
            }
        },
        validateWz5BeforeShowSendButton: function () {
            let data = this.params;
            return !!this.validateForm(data);
        },

        prepareDecisions: function (data) {
            switch (data.current_form) {
                case 'J':
                    if (data.decision === 'true') {
                        return {'decision': 'yes', 'decision_answer': 'Zgoda na wymianę urządzenia'}
                    }
                    if (data.decision === 'false') {
                        return {'decision': 'no', 'decision_answer': 'Brak zgody na wymianę'}
                    }
                    break;
            }
        },

        /**
         * Submit (send to backend) selected decision
         */
        submitWz5CaseDecision: function (decision) {
            this.updateWz5Form({
                key: 'decision_message',
                value: decision.decision_answer
            });
            this.updateWz5Form({
                key: 'decision',
                value: decision.decision
            });
            let storeStatus =
                this.storeWzCaseDecision();
            const checkStatus = async () => {
                const status = await storeStatus;
                if (status) {
                    this.$router.push('success');
                }
            };
            checkStatus();
        }
    }
}